import { forEach } from "lodash";
import { UseFormSetValue } from "react-hook-form";

import { UnitLevelUnderwritingAnswers } from "@covertree/types";

import { UnderwritingQuestionsForm } from "../../validatorsAndTypes/underwritingQuestions";

export function getRelatedFormFields(
  question: UnitLevelUnderwritingAnswers
): (keyof UnderwritingQuestionsForm)[] {
  switch (question) {
    case UnitLevelUnderwritingAnswers.BusinessOnPremises:
      return [
        "daycareOnPremises",
        "businessEmployeesOnPremises",
        "visitorsInAMonth",
        "businessDescription",
      ];

    case UnitLevelUnderwritingAnswers.CancellationRenew:
      return ["reasonCancellationRenew"];

    case UnitLevelUnderwritingAnswers.SourceOfHeat:
      return ["sourceOfHeatInstallation", "typeOfFuel", "pleaseDescribe"];

    case UnitLevelUnderwritingAnswers.SwimmingPool:
      return [
        "fourFeetFence",
        "divingBoard",
        "divingBoardSlideLiabilityExtension",
      ];

    case UnitLevelUnderwritingAnswers.TrampolineLiability:
      return ["trampolineSafetyNet", "trampolineLiabilityExtension"];

    case UnitLevelUnderwritingAnswers.BurglarAlarm:
      return ["burglarAlarmValue"];

    case UnitLevelUnderwritingAnswers.StormMitigationFortified:
      return ["stormMitigationFortifiedValue"];

    default:
      return [];
  }
}

export function resetRelatedFields(
  setValue: UseFormSetValue<UnderwritingQuestionsForm>,
  question: UnitLevelUnderwritingAnswers
) {
  forEach(getRelatedFormFields(question), (field) =>
    // setValue to null insted of resetting field because reset gets value from defaultValues which not always is undefined
    setValue(field, null, { shouldValidate: false })
  );
}
